import ColoredShape from "./ColoredShape";

export default ColoredShape;
